import styled from "styled-components";
import FormComp from "../../Componentes/FormComp";
import Overlay from "../../Componentes/Overlay";
import Formulario from "../../Componentes/Utils/Formulario";
import Modal from "../../Componentes/Utils/Modal";
import Tabela from "../../Componentes/Utils/Tabela";
import SmallLoading from "../../Componentes/Utils/SmallLoading";

import { useModal } from "../../contexts/ModalContext";
import { useEffect, useState } from "react";
import axios from "axios";

const ContainerExames = styled.div`
    width: 100%;
    margin-top: 10px;
    & h3 {
        margin: 13px 0 10px 0;
        color: #000;
        text-align: center;
    }
`
const ContainerLoading = styled.div`
    width: 360px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    background-color: #fff;
    border-radius: 12px;
    & p {
        color: #000;
        font-size: 16px;
        font-weight: 500;
    }
`
const LinhaTabelaExames = styled.tr`
    color: #000 !important;
`

const ModalNewAso = ({ fetchSuccess, closeAso, idAsoEdit }) => {

    const { closeModal } = useModal();

    const [loading, setLoading] = useState(true);

    const [obrasOpt, setObrasOpt] = useState([]);
    const [clinicasOpt, setClinicasOpt] = useState([]);
    const tiposAso = [
        { label: "ADMISSIONAL", value: "0" },
        { label: "PERIÓDICO", value: "1" },
        { label: "RETORNO AO TRABALHO", value: "2" },
        { label: "MUDANÇA DE FUNÇÃO", value: "3" },
        { label: "DEMISSÃO", value: "9" }
    ]
    const [funcoesOpt, setFuncoesOpt] = useState([]);

    const fetchOptions = async () => {

        try {

            setLoading(true);

            const [obrasResponse, clinicasResponse] = await Promise.all([
                axios.get("https://sistemaintegrado.palmont.com.br/Painel/API/GetObrasAtivas/"),
                axios.get("https://sistemaintegrado.palmont.com.br/Painel/API/ASO/GetClinicas/")
            ])

            let ObrasList = obrasResponse.data.map(obra => obra.OBRA);

            setObrasOpt(ObrasList);
            setClinicasOpt(
                clinicasResponse.data.map((obj) => ({
                    label: obj.clinica,
                    value: obj.identifier
                }))
            );

        } catch (e) {

            console.error(e);

        } finally {

            setLoading(false);

        }

    }

    const [formValues, setFormValues] = useState({
        obra: "",
        tipoAso: "",
        cpf: "",
        nome: "",
        dataNascimento: "",
        funcao: "",
        exames: [],
        clinica: "",
        dataExame: "",
        exameRealizado: null
    })

    const [exames, setExames] = useState([]);

    const handleChange = (field) => (event) => {

        let { value } = event.target;

        if (field === 'cpf') {
            value = value.replace(/\D/g, '');

            if (value.length > 3) value = value.replace(/^(\d{3})(\d)/, '$1.$2');
            if (value.length > 7) value = value.replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3');
            if (value.length > 11) value = value.replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4');

            value = value.slice(0, 14);
        }

        setFormValues((prev) => ({

            ...prev,
            [field]: value

        }))

    }

    useEffect(() => {

        console.log(formValues);

    }, [formValues]);

    useEffect(() => {

        if (idAsoEdit) return;

        const getInfoByCPF = async () => {

            try {

                setLoading(true);

                let formatedCPF = formValues.cpf.replace(/\D/g, "");

                const { data } = await axios.post("https://sistemaintegrado.palmont.com.br/Painel/API/ASO/GetExamesByFunc/", {
                    cpf: formatedCPF,
                    tipo_aso: formValues.tipoAso,
                    obra: formValues.obra,
                    nova_func: formValues.funcao,
                });

                console.log(data);

                let DataNasc = "";
                const nasc = data.COLAB?.DATA_NASC;

                if (nasc && nasc.length === 8) {
                    const year = nasc.substring(0, 4);
                    const month = nasc.substring(4, 6);
                    const day = nasc.substring(6, 8);
                    DataNasc = `${year}-${month}-${day}`;
                } else {
                    DataNasc = nasc || "";
                }

                setExames(data.EXAMES || []);

                if (data.STATUS === "SUCCESS") {

                    setFormValues((prev) => ({
                        ...prev,
                        nome: data.COLAB.NOME,
                        funcao: data.COLAB.FUNCAO,
                        dataNascimento: DataNasc,
                    }));

                } else {

                    alert("NENHUM COLABORADOR ENCONTRADO");

                }

            } catch (e) {

                console.error(e);

            } finally {

                setLoading(false);

            }

        }

        if (formValues.cpf.length === 14) {

            if (formValues.tipoAso === "3" && formValues.funcao) {

                getInfoByCPF();

            } else if (formValues.tipoAso !== "3") {

                getInfoByCPF();

            }

        } else {

            setFormValues((prev) => ({
                ...prev,
                nome: "",
                dataNascimento: "",
                funcao: ""
            }));
            setExames([]);

        }

    }, [formValues.cpf, formValues.funcao, formValues.tipoAso, formValues.obra]);

    useEffect(() => {

        const getFuncoes = async () => {

            try {

                setLoading(true);

                const { data } = await axios.get("https://sistemaintegrado.palmont.com.br/Painel/API/GetFunctions/");
                setFuncoesOpt(data);

            } catch (e) {
                console.error(e);
            } finally {
                if( !idAsoEdit ){
                    setLoading(false);
                }
            }

        }

        if (formValues.tipoAso === "3") {
            getFuncoes();
        }

    }, [formValues.tipoAso]);

    useEffect(() => {

        console.log(exames);

    }, [exames]);

    const handleSubmit = async (e) => {

        e.preventDefault();

        if( idAsoEdit ){
            return;
        }

        setLoading(true);

        try {

            const formData = new FormData();

            for (let key in formValues) {
                formData.append(key, formValues[key]);
            }

            formData.append('exames', JSON.stringify(exames));

            const { data } = await axios.post("https://sistemaintegrado.palmont.com.br/Painel/API/ASO/SaveASO/", formData, { withCredentials: true });
            console.log(data);

        } catch (e) {
            console.error(e);
        } finally {

            if (fetchSuccess) {

                await fetchSuccess()

            }
            closeModal();

            setLoading(false);
        }

    }

    const getAsoEdit = async () => {

        try {

            const { data } = await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/ASO/GetAsoInfo/', {
                id: idAsoEdit
            })

            setFormValues((prev) => ({

                ...prev,
                obra: data.obra,
                tipoAso: data.tipo_aso,
                cpf: data.cpf,
                nome: data.nome,
                dataNascimento: data.data_nasc,
                funcao: data.funcao,
                clinica: data.clinica,
                dataExame: data.data,
                exameRealizado: null

            }))

            setExames( data.exames )

        } catch (error) {

            console.error(error);

        } finally {

            setLoading(false);

        }
    }

    useEffect(() => {

        const init = async () => {

            await fetchOptions();

            if( idAsoEdit ){
                await getAsoEdit();
            }

        }

        init();

    }, [])

    return (
        <>
            <Overlay state={true} >
                <Modal header={true} close={closeAso} >
                    <Formulario onSubmit={(e) => handleSubmit(e)} >
                        <FormComp
                            title="CENTRO CUSTO"
                            type="select"
                            required
                            options={obrasOpt}
                            changeFunc={handleChange('obra')}
                            valor={formValues.obra}
                            disabled={idAsoEdit}
                        />
                        <FormComp
                            title="TIPO DE ASO"
                            type="select"
                            required
                            options={
                                tiposAso.map((tipo) => (
                                    <option value={tipo.value} key={tipo.value} >{tipo.label}</option>
                                ))
                            }
                            mapped
                            changeFunc={handleChange('tipoAso')}
                            valor={formValues.tipoAso}
                        />
                        <FormComp
                            title="CPF"
                            type="text"
                            required
                            maxLength={14}
                            changeFunc={handleChange('cpf')}
                            valor={formValues.cpf}
                        />
                        <FormComp
                            title="NOME"
                            type="text"
                            required
                            readOnly
                            valor={formValues.nome}
                        />
                        <FormComp
                            title="DATA DE NASCIMENTO"
                            type="date"
                            required
                            readOnly
                            valor={formValues.dataNascimento}
                        />
                        {formValues.tipoAso === "3" ? (
                            <FormComp
                                title="FUNÇÃO"
                                type="select"
                                required
                                options={funcoesOpt}
                                changeFunc={handleChange('funcao')}
                                valor={formValues.funcao}
                            />
                        ) : (
                            <FormComp
                                title="FUNÇÃO"
                                type="text"
                                required
                                readOnly
                                valor={formValues.funcao}
                            />
                        )}
                        <ContainerExames>
                            <h3>LISTA DE EXAMES</h3>
                            <Tabela>
                                <tbody>
                                    {
                                        exames.length > 0 ? (
                                            exames.map((exame, index) => (
                                                <LinhaTabelaExames key={index} >
                                                    <td>{exame.EXAME}</td>
                                                </LinhaTabelaExames>
                                            ))
                                        ) : (
                                            <tr>
                                                <td style={
                                                    { textAlign: "center", color: "#000" }
                                                } >NENHUM EXAME CADASTRADO</td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </Tabela>
                        </ContainerExames>
                        <FormComp
                            title="CLÍNICA"
                            type="select"
                            required
                            options={clinicasOpt.sort()}
                            obj
                            changeFunc={handleChange('clinica')}
                            valor={formValues.clinica}
                        />
                        <FormComp
                            title="DATA DO EXAME"
                            type="date"
                            required
                            changeFunc={handleChange('dataExame')}
                            valor={formValues.dataExame}
                        />
                        <FormComp
                            title="EXAME REALIZADO"
                            type="select"
                            required
                            options={["SIM"]}
                            changeFunc={handleChange('exameRealizado')}
                            valor={formValues.exameRealizado}
                        />
                        <FormComp
                            valor="SALVAR"
                            type="submit"
                        />
                    </Formulario>
                    {
                        loading &&
                        <Overlay state={true}>
                            <ContainerLoading>
                                <SmallLoading />
                            </ContainerLoading>
                        </Overlay>
                    }
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalNewAso;